import React from 'react'
import { Link } from 'react-router-dom'

function ComingSoon({ pageName }) {
  return (
    <>
        <section className="event event03 pt-120 pb-120 p-relative fix">
            <div className="container">
                <div className="row">
                <div className="col-lg-12 col-md-12 text-center wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">

                    {/* Icon */}
                    <div style={{
                        width: "90px", height: "90px", borderRadius: "50%",
                        background: "linear-gradient(135deg, #e8f0fb 0%, #fff4ec 100%)",
                        border: "2px solid #b8d0f0",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        margin: "0 auto 2rem"
                    }}>
                        <i className="fal fa-clock" style={{ fontSize: "36px", color: "#1E5AA8" }} />
                    </div>

                    {/* Coming Soon heading */}
                    <h1 style={{
                        fontSize: "64px", fontWeight: 900, lineHeight: 1,
                        background: "linear-gradient(135deg, #1E5AA8 0%, #0d3d7a 100%)",
                        WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                        margin: "0 0 0.5rem"
                    }}>
                        Coming Soon
                    </h1>

                    {/* Orange accent line */}
                    <div style={{
                        width: "60px", height: "4px", borderRadius: "4px",
                        background: "linear-gradient(90deg, #F27024, #ffb347)",
                        margin: "0 auto 1.75rem"
                    }} />

                    <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#111827", marginBottom: "1rem" }}>
                        {pageName} — We're Working on It!
                    </h2>

                    <p style={{
                        fontSize: "16px", color: "#6b7280", lineHeight: 1.8,
                        maxWidth: "500px", margin: "0 auto 2.5rem"
                    }}>
                        We are busy putting together something great for you.
                        This page will be live soon. In the meantime, feel free
                        to explore the rest of the Anjanadri Institute of Pharmacy website.
                    </p>

                    {/* Buttons */}
                    <div style={{ display: "flex", justifyContent: "center", gap: "16px", flexWrap: "wrap" }}>
                        <Link to="/" className="btn ss-btn">
                            Back to Home <i className="fal fa-long-arrow-right" />
                        </Link>
                        <Link to="/contact-us" className="btn ss-btn" style={{
                            background: "transparent", border: "2px solid #1E5AA8",
                            color: "#1E5AA8"
                        }}>
                            Contact Us <i className="fal fa-long-arrow-right" />
                        </Link>
                    </div>

                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default ComingSoon
